import React, {useState} from "react";

import './_reports.scss'
import {Breadcrumb, BreadcrumbItem, Column, DatePicker, DatePickerInput, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import ReportsTable from "../../components/ReportsTable";
import UnreportedSystemsTable from "../../components/UnreportedSystemsTable";
import moment from "moment";

const Reports = () => {
  const [date, setDate] = useState(moment().format("DD/MM/YYYY"))
  return (
    <Grid fullWidth className="reports-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Reports
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Reports
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="reports-page__r1">
            <Tile>
              <DatePicker
                datePickerType="single"
                dateFormat="d/m/Y"
                locale="it"
                value={date}
                onClose={(raw, date) => {
                  setDate(date)
                }}>
                <DatePickerInput
                  placeholder="dd/mm/yyyy"
                  labelText="Data di riferimento"
                  id="date-picker-single"
                  size="md"/>
              </DatePicker>
            </Tile>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="reports-page__r1">
            <Tile>
              <UnreportedSystemsTable DateRef={date} />
            </Tile>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="reports-page__r1">
            <Tile>
              <ReportsTable DateRef={date} />
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Reports